import { z } from 'zod';
import { DateTimeSchema, objectIdRef, ObjectIdSchema, ObjectIdString } from '../../common.js';
import { CandidateActivity, NlpData, RelatedEntityMetadata } from '../../../interfaces.js';
import { IntegrationType } from '../integrationSchema.js';

export const LinkedEntityLookupMetadataEntry = z.object({
  id: ObjectIdString.nullish(),
  sourceId: z.string().nullish(),
  lookupDate: DateTimeSchema,
});
export type LinkedEntityLookupMetadataEntry = z.infer<typeof LinkedEntityLookupMetadataEntry>;

export const IAtsEntity = z.object({
  _id: ObjectIdSchema,
  account: objectIdRef('Account'),
  integration: objectIdRef('Integration'),
  integrationType: IntegrationType,
  entityType: z.string(),
  apiName: z.string(),
  sourceId: z.string(),
  departmentKey: z.string().array().nullish(),
  rawData: z.looseObject({
    id: z.string().or(z.number()),
  }),
  mappedData: CandidateActivity.nullish(),
  nlpData: NlpData.nullish(),
  metadata: z.object({
    dateLastFetched: DateTimeSchema,
    relatedEntities: z.map(z.string(), RelatedEntityMetadata),
    linkedEntityLookups: z.map(z.string(), LinkedEntityLookupMetadataEntry).nullish(),
  }),
  timestamp: DateTimeSchema.nullish(),
  sourceDateAdded: DateTimeSchema.nullish().describe('When the entity was added to the source ATS'),
  createdAt: DateTimeSchema,
  updatedAt: DateTimeSchema,
});
export type IAtsEntity = z.infer<typeof IAtsEntity>;
